import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import "./SaaSUIToolkit.css";

export const SaaSSectionHeader = ({
  title,
  subtitle,
  linkTo,
  linkLabel = "View All",
  badge,
}) => {
  return (
    <div className="saas-section-header">
      <div>
        <div className="d-flex align-items-center gap-2">
          <h2 className="saas-section-header__title">{title}</h2>
          {badge && <span className="saas-badge saas-badge--blue">{badge}</span>}
        </div>
        {subtitle && (
          <p className="text-muted mb-0" style={{ fontSize: "0.8125rem", marginTop: 2 }}>
            {subtitle}
          </p>
        )}
      </div>
      {linkTo && (
        <Link to={linkTo} className="saas-section-header__link">
          <span>{linkLabel}</span>
          <FiArrowRight size={14} />
        </Link>
      )}
    </div>
  );
};

export default SaaSSectionHeader;
